import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal, RevealLineOnScroll } from "./Reveal";
import { WHY, EASE } from "../data";

export const WhyStraight = () => {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="bg-white text-black pt-16 md:pt-20 pb-10 md:pb-12 border-t"
      style={{ borderColor: "var(--border-light)" }}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="mb-12 md:mb-16">
          <Reveal>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[color:var(--primary-accent)] mb-6">
              Why Straight
            </p>
          </Reveal>
          {/* <h2 className="font-display text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight leading-[1.02]">
            <RevealLineOnScroll>Built different.</RevealLineOnScroll>
          </h2> */}
        </div>

        <div className="grid md:grid-cols-3 gap-4 md:gap-6">
          {WHY.map((item, i) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, ease: EASE, delay: (i % 3) * 0.08 }}
              className={`${item.span} group rounded-2xl border bg-[#f5f5f7] p-8 md:p-10 flex flex-col justify-between min-h-[160px] hover:border-[color:var(--primary-accent)] transition-colors duration-500`}
              style={{ borderColor: "var(--border-light)" }}
              data-testid={`why-card-${i}`}
            >
              <div className="flex items-start justify-between">
                <span className="font-mono-str text-xs text-black/30">
                  0{i + 1}
                </span>
                <ArrowUpRight
                  size={18}
                  className="text-black/25 group-hover:text-[color:var(--primary-accent)] transition-colors duration-300"
                />
              </div>
              <div>
                <h3 className="font-display text-2xl md:text-3xl font-semibold tracking-tight mb-3">
                  {item.title}
                </h3>
                <p className="text-base text-black/55">{item.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
